import axios from "axios"
import * as api from '@/request/front'

function setFavicon(url) {
    let link = document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = url;
    document.getElementsByTagName('head')[0].appendChild(link);
}
function updateFavicon(url) {
    let links = document.getElementsByTagName('link');
    for (let link of links) {
        if (link.getAttribute('rel') === 'shortcut icon' || link.getAttribute('rel') === 'icon') {
            link.href = url;
            break; // 假设只需要更新一个，找到后即退出循环
        }
    }
}

export default {

    state: () => ({
        websitConfig: {}
    }),

    mutations: {
        setWebsitConfig(state, value) {
            state.websitConfig = value
        }
    },

    getters: {
        getWebsitConfigValue(state) {
            return state.websitConfig
        }
    },

    actions: {
        getWebsitConfig({commit}) {
            axios.get('https://www.dfshuke.com/pro-api/pc/websiteSettings/selectWebsiteSettings?websiteId=10000002').then(res => {
                commit('setWebsitConfig', res.data.data)
                
            })

        }
    }
}